import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export type ShowInVariant =
  | "desktopUp"
  | "mobileAndTablet"
  | "mobileOnly"
  | "mobileUp"
  | "tabletUp";

export type SwapCondition = "mobile" | boolean;

type ResponsiveContainerProps = {
  $hideOnSwap?: SwapCondition;
  $shouldSwap?: boolean;
  $showIn?: ShowInVariant;
  $showOnSwap?: SwapCondition;
};

export const ResponsiveContainer = styled.div<ResponsiveContainerProps>`
  /* =========================================
     Layer 1: Responsive Base
     ========================================= */

  display: ${({ $showIn = "mobileUp" }) =>
    $showIn === "mobileUp" || $showIn === "mobileOnly" || $showIn === "mobileAndTablet"
      ? "flex"
      : "none"};

  ${theme.breakpoints.up("tablet")} {
    ${({ $showIn }) =>
      $showIn === "tabletUp" &&
      css`
        display: flex;
      `}

    ${({ $showIn }) =>
      $showIn === "mobileOnly" &&
      css`
        display: none;
      `}
  }

  ${theme.breakpoints.up("desktop")} {
    ${({ $showIn }) =>
      $showIn === "desktopUp" &&
      css`
        display: flex;
      `}

    ${({ $showIn }) =>
      $showIn === "mobileAndTablet" &&
      css`
        display: none;
      `}
  }

  /* =========================================
     Layer 2: State Filter (時機層)
     ========================================= */

  ${({ $shouldSwap, $showOnSwap }) =>
    $showOnSwap === true &&
    !$shouldSwap &&
    css`
      display: none;
    `}

  ${({ $hideOnSwap, $shouldSwap }) =>
    $hideOnSwap === true &&
    $shouldSwap &&
    css`
      display: none;
    `}


  ${({ $hideOnSwap, $shouldSwap }) =>
    $hideOnSwap === "mobile" &&
    $shouldSwap &&
    css`
      ${theme.breakpoints.down("tablet")} {
        display: none;
      }
    `}

${({ $shouldSwap, $showOnSwap }) =>
    $showOnSwap === "mobile" &&
    !$shouldSwap &&
    css`
      ${theme.breakpoints.down("tablet")} {
        display: none !important;
      }
    `}
`;
